import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React, { useState } from "react";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  index?: number;
  onValueChanged?: (e: any, index: number) => void;
  value?: any;
  tableName?: string;
  tableFieldName?: string;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
  modelField?: string;
}

export const NFLookupUnit = ({
  title,
  fieldName,
  required,
  showBorder,
  width,
  value,
  onValueChanged,
  index,
  tableFieldName,
  tableName,
  selectedCatalog,
  setSelectedCatalog,
  modelField,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.Unit.getDataService().GetAll(searchText);
  };

  return (
    <>
      <NFLookupCatalog
        fieldName={fieldName}
        title={title}
        entity={AppEntities.Unit}
        width={width}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        value={value}
        onValueChanged={onValueChanged}
        index={index}
        tableFieldName={tableFieldName}
        tableName={tableName}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
        modelField={modelField}
      >
        <NFLookupCatalogColumn fieldName={"id"} caption={"Id"} />
        <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} />
      </NFLookupCatalog>
    </>
  );
};
